import { useEffect } from 'react';
import type { NavigateFunction } from 'react-router-dom';

type RoutesShape = {
  TRAVELLER_DETAILS: string;
  [key: string]: string;
};

export const useRedirectHandler = (currentPath: string, routes: RoutesShape, lang: string, navigate: NavigateFunction) => {
  useEffect(() => {
    if (currentPath.includes('notfound')) {
      // eslint-disable-next-line no-console
      console.log('Redirecting from notfound to traveller details');
      navigate(`${routes.TRAVELLER_DETAILS}?lang=${lang}`, { replace: true });
    }
  }, [currentPath, navigate, routes, lang]);
};
